class SpellsEdit{
    constructor ($http, $scope) {
        this.$http = $http;
        this.$scope = $scope;
        this.spells = [];
        this.selected = {id: 0};
        this.hidechecked = true;

        this.modelClasses = [
             {name: "ART", value: "artificer"},
             {name: "BRD", value: "bard"},
             {name: "CLR", value: "cleric"},
             {name: "DRD", value: "druid"},
             {name: "PLD", value: "paladin"},
             {name: "RNG", value: "ranger"},
             {name: "SRC", value: "sorcerer"},
             {name: "WRK", value: "warlock"},
             {name: "WZD", value: "wizard"}
        ];

        this.get();
    }

    add () {
        this.spells.push({Ru: {}, En: {}});
        this.selected = this.spells[this.spells.length - 1];
    };

    select (sp) {
        this.selected = sp;
        if(!this.selected.School)
            this.selected.School = this.selected.En.School;
        if(!this.selected.Level)
        this.selected.Level = this.selected.En.Level;
    };

    clean (spd) {
        spd.Description = spd.Description.replace(/-?\r*\n/g, "");
    };

    set () {
        this.$http({
            url: "/api/spells/set",
            method: "post",
            data: jQuery.param({
                data: JSON.stringify(this.selected)
            }),
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then((resp) => {
            console.log(resp);
            this.get();
        }, (err) => {
            console.log(err);
        });
    };

    get() {
        this.$http({
            url: "/api/spells/get",
            method: "get"
        }).then(
            (resp) => {
                console.log(resp);
                this.data = resp.data;
                this.spells = resp.data.spells;
            },
            (err) => {
                console.log(err);
            }
        );
    };
}

SpellsEdit.$inject = ['$http', '$scope'];

export {SpellsEdit};